/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import './breadcrumb-lista.css';
import Buscador from '../buscadores/buscador-vertical/buscador';
import { getLocationInfo } from '../../api/http-client';

class Breadcrumb extends Component {
  constructor(props) {
    super(props);
    const { pathname } = getLocationInfo();
    const [
      base,
      modulePath,
      categoriaId,
      title,
    ] = (pathname.slice(0, 1) === '/' ? pathname.slice(1, [pathname.length - 1]) : pathname).split('/');
    this.state = {
      base,
      modulePath,
      categoriaId,
      title,
    };
  }

  render() {
    const { hostname, href } = getLocationInfo();
    const { modulePath, title } = this.state;
    return (
      <div className='breadcrumb-panel-paquete-container'>
        <div className='breadcrumb-panel-paquete'>
          <div style={{ marginLeft: 'auto', marginRight: 'auto', display: 'inherit' }}>
            <ul className='breadcrumb-lista'>
              <li><a href='/'>{ hostname }</a></li>
              <li>
                <a href={process.env.RAZZLE_URL}>
                  {' '}
                  { modulePath }
                  {' '}
                </a>
              </li>
              <li className='active'><a href={href}>{ title }</a></li>
              {/* <li className="active"><span className="breadcrum-text"> dest - mes </span></li> */}
            </ul>
            <div className='panel-heading hidden-xs btn-collapse btn-busqueda' role='tab' id='headingThree'>
              <h4
                style={{ paddingTop: '8px', display: 'inline-block' }}
                className='panel-title text-center'
                role='button'
                data-toggle='collapse'
                href='#collapseBuscador1'
                aria-expanded='false'
                aria-controls='collapseBuscador'
              >
                <a className='collapsed' href='#' onClick={(e) => [e.preventDefault()]}>
                  {t('packages_list.modify_search')}
                </a>
              </h4>
            </div>
          </div>
        </div>
        <div className='collapse-container-buscador'>
          <div
            id='collapseBuscador1'
            className='panel-collapse collapse breadcrumb-panel-buscador'
            role='tabpanel'
            aria-labelledby='headingThree'
          >
            <div className='breadcrum-contenedor-buscador color-dinamico-fondo'>
              <div className='container color-dinamico-fondo'>
                {typeof window === 'undefined'
                  ? null
                  : (<Buscador idUnico='searcher-breadcrum' />)}
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

export default withTranslation()(Breadcrumb);
